import { styled, TableCell, TableRow } from '@shared/components';

import { useItemAnalysisSearchParams } from '../../hooks';
import { type ItemAnalysisTableData } from '../../types';

export interface ItemAnalysisDiscriminantTableBodyProps {
  rows: ItemAnalysisTableData;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.grey[300],
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  ...theme.typography.body2Semibold,
}));

export default function ItemAnalysisDiscriminantTableBody(
  props: Readonly<ItemAnalysisDiscriminantTableBodyProps>,
) {
  const [{ pageSize, page }] = useItemAnalysisSearchParams();
  const { rows } = props;
  return (
    <>
      {rows.map((row, rowIndex) => {
        return (
          <TableRow key={row.questionRefCode} sx={{ border: 'none' }}>
            <StyledTableCell align='center' sx={{ minWidth: '64px' }}>
              {rowIndex + 1 + page * pageSize}
            </StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
              {row.questionRefCode}
            </StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: '100px' }}>
              {row.answer}
            </StyledTableCell>
            {row.numbersOfPassed.map((numPass, passIndex) => (
              <StyledTableCell
                sx={{
                  backgroundColor: (theme) =>
                    numPass.answer === row.answer ? theme.palette.success.light : undefined,
                  minWidth: '90px',
                }}
                align='center'
                key={`passed-${rowIndex}-${passIndex}`}
              >
                {numPass.total ?? '-'}
              </StyledTableCell>
            ))}
            <StyledTableCell
              sx={{
                backgroundColor: (theme) => theme.palette.grey[100],
                minWidth: '90px',
              }}
              align='center'
            >
              {row.totalNumberOfPassed}
            </StyledTableCell>
            {row.numbersOfFailed.map((numPass, failIndex) => (
              <StyledTableCell
                sx={{
                  backgroundColor: (theme) =>
                    numPass.answer === row.answer ? theme.palette.success.light : undefined,
                  minWidth: '90px',
                }}
                align='center'
                key={`failed-${rowIndex}-${failIndex}`}
              >
                {numPass.total ?? '-'}
              </StyledTableCell>
            ))}
            <StyledTableCell
              sx={{
                backgroundColor: (theme) => theme.palette.grey[100],
                minWidth: '90px',
              }}
              align='center'
            >
              {row.totalNumberOfFailed}
            </StyledTableCell>
            <StyledTableCell
              sx={{
                backgroundColor: (theme) => theme.palette.primary.light,
                p: (theme) => theme.spacing(2, 3),
                minWidth: '100px',
              }}
              align='center'
            >
              {row.bIndex.toFixed(2) ?? '-'}
            </StyledTableCell>
          </TableRow>
        );
      })}
    </>
  );
}
